import React from 'react';
import css from './StepLabel.module.css';
import { StepState } from '../stepState';
import { Paragraph, H3 } from '../../../text';

export interface StepLabelProps {
  label: string;
  stepState: StepState;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
}

const StepLabel: React.FC<StepLabelProps> = (props: StepLabelProps) => {
  return (
    <div
      onMouseEnter={() => props.onMouseEnter()}
      onMouseLeave={() => props.onMouseLeave()}
      onClick={() => props.onClick()}
    >
      {props.stepState === StepState.Active ? (
        <H3 className={css.stepLabelActive} text={props.label} />
      ) : (
        <Paragraph text={props.label} />
      )}
    </div>
  );
};

export default StepLabel;
